module.exports = __webpack_public_path__ + "img/Authorized.d7a05b4d.png";